import { ChargePoint } from '../redux/api/web-api'
import { hasFeature } from '../services/ocppService'
import { isAura2 } from '../utils/chargePointProductUtils'
import isAura from '../../lib/isAura'
import isDawn from '../../lib/isDawn'
import isLuna from '../../lib/isLuna'

const MIN_AURA_SMART_SCHEDULE_FIRMWARE = 110
const MIN_HALO2_SMART_SCHEDULE_FIRMWARE = 130

const hasSmartSchedulingFeature = (chargePoint: ChargePoint): boolean =>
    (isDawn(chargePoint) || isLuna(chargePoint)) && hasFeature('SmartCharging', chargePoint.ocppConfigKeys)

export function doesSupportSmartSchedule(chargePoint?: ChargePoint): boolean {
    if (!chargePoint) return false
    if (isAura2(chargePoint)) return true
    if (isAura(chargePoint) && Number(chargePoint.installedFirmwareVersion) >= MIN_AURA_SMART_SCHEDULE_FIRMWARE)
        return true
    if (
        chargePoint.productType === 'Halo2' &&
        Number(chargePoint.installedFirmwareVersion) >= MIN_HALO2_SMART_SCHEDULE_FIRMWARE
    )
        return true
    if (hasSmartSchedulingFeature(chargePoint)) return true
    return false
}

export const canShowSmartScheduling = (chargePoint?: ChargePoint, isSuperAdmin = false): boolean => {
    if (!chargePoint) return false
    if (!isDawn(chargePoint) && chargePoint.ocppServerMode === 'Internal') return true
    return hasSmartSchedulingFeature(chargePoint) || ((isDawn(chargePoint) || isLuna(chargePoint)) && isSuperAdmin)
}
